import { Dispatch } from "redux";
import { setWarningMessage } from "../../Redux/Slices/alert.slice";

export const validateResultData = (
  data: {
    resultType: string;
    schoolBranchId: number | null;
    totalAttendance: number | null;
  },
  dispatch: Dispatch,
) => {
  const { resultType, schoolBranchId, totalAttendance } = data;

  if (!resultType) {
    dispatch(setWarningMessage("Please enter result."));
    return false;
  }

  if (!schoolBranchId) {
    dispatch(setWarningMessage("Please select school branch."));
    return false;
  }

  if (!totalAttendance) {
    dispatch(setWarningMessage("Please enter total attendance."));
    return false;
  }

  return true;
};
